import React from "react";
import { STEPS, useBooking } from "@/context/BookingContext";

const LABELS = {
    category: "Category",
    service: "Treatment",
    date: "Date",
    time: "Time",
    details: "Details",
    review: "Review",
    success: "Done",
};

export function StepProgress() {
    const { step } = useBooking();
    const currentIndex = STEPS.indexOf(step);
    const visibleSteps = STEPS.slice(0, 6); // hide "success"
    return (
        <div className="flex items-center justify-between gap-1 px-1" data-testid="step-progress">
            {visibleSteps.map((s, i) => {
                const active = i === currentIndex;
                const done = i < currentIndex;
                return (
                    <div key={s} className="flex-1 flex flex-col items-center gap-1.5">
                        <div
                            className={`h-[2px] w-full rounded-full transition-all duration-500 ${
                                done ? "bg-gold" : active ? "bg-gold/80" : "bg-white/10"
                            }`}
                        />
                        <span
                            className={`text-[9px] uppercase tracking-[0.18em] transition-colors ${
                                active ? "text-gold" : done ? "text-white/60" : "text-white/25"
                            }`}
                        >
                            {LABELS[s]}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}
